document.addEventListener('DOMContentLoaded', function () {
  var heads = document.querySelectorAll('.intc-faq__accordion-head');

  heads.forEach(function (head) {
    head.addEventListener('click', function () {
      var part = head.closest('.intc-faq__accordion-part');
      var content = part.querySelector('.intc-faq__accordion-content');
      var isActive = part.classList.contains('active');

      // Close all other open items instantly to their actual height then to 0
      document.querySelectorAll('.intc-faq__accordion-part.active').forEach(function (p) {
        if (p !== part) {
          var c = p.querySelector('.intc-faq__accordion-content');
          c.style.maxHeight = '0';
          p.classList.remove('active');
        }
      });

      if (isActive) {
        content.style.maxHeight = '0';
        part.classList.remove('active');
      } else {
        part.classList.add('active');
        content.style.maxHeight = content.scrollHeight + 'px';
      }
    });
  });
});
